export async function fetchPressAndMedia(page = 1, pageSize = 6) {
  const baseUrl = process.env.NEXT_PUBLIC_SERVER_URL;

  let query = `?populate=*&pagination[page]=${page}&pagination[pageSize]=${pageSize}`;
  query += `&sort=publish_date:desc`;
  const url = `${baseUrl}/press-and-medias${query}`;

  // const url = `${baseUrl}/press-and-medias/?populate=*&pagination[page]=${page}&pagination[pageSize]=${pageSize}`;

  const res = await fetch(url, { cache: "no-store" });

  if (!res.ok) {
    throw new Error("Failed to fetch press and media");
  }

  return res.json();
}
export async function fetchPressAndMediaBySlug(slug) {
  const baseUrl = process.env.NEXT_PUBLIC_SERVER_URL;

  const url = `${baseUrl}/press-and-medias?filters[slug][$eq]=${slug}&populate=*`;

  const res = await fetch(url, { next: { revalidate: 60 } });

  if (!res.ok) {
    throw new Error("Failed to fetch press and media item");
  }

  const json = await res.json();

  // Strapi returns an array even for single slug — grab first item
  const raw = json?.data?.[0];
  if (!raw) return null;

  // Unwrap Strapi v4 attributes
  return { id: raw.id, ...(raw.attributes ?? raw) };
}

export async function getRecentItems(excludeSlug) {
  try {
    const res = await fetchPressAndMedia(1, 5);
    // Strapi 5 — fields directly on item
    return (res?.data || [])
      .filter((item) => item.slug !== excludeSlug)
      .slice(0, 4)
      .map((item) => ({
        id: item.id,
        title: item.title,
        slug: item.slug,
        date: item.publish_date,
        imageUrl: item?.Media_images?.[0]?.url ?? "/default.jpg",
      }));
  } catch {
    return [];
  }
}
export async function CalendarIcon() {
  return (
    <svg className="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path strokeLinecap="round" d="M16 2v4M8 2v4M3 10h18" />
    </svg>
  );
}
export async function PublisherIcon() {
  return (
    <svg className="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
      <path strokeLinecap="round" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v12a2 2 0 01-2 2zM3 10h18" />
    </svg>
  );
}
export async function ExternalLinkIcon() {
  return (
    <svg className="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M14 3h7m0 0v7m0-7L10 14M5 5H3a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-2" />
    </svg>
  );
}
export async function ArrowLeftIcon() {
  return (
    <svg className="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
    </svg>
  );
}
export async function FacebookIcon() {
  return <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" /></svg>;
}
export async function XIcon() {
  return <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>;
}
export async function LinkedInIcon() {
  return <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" /><circle cx="4" cy="4" r="2" /></svg>;
}


// ─── Icons ─────────────────────────────────────────────────────────────────────
export  async function ShareButton({ href, label, color, children }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className={`inline-flex items-center justify-center w-8 h-8 rounded-full text-white ${color} hover:opacity-80 transition-opacity`}
    >
      {children}
    </a>
  );
}
